module.exports = __webpack_public_path__ + "static/media/proj19_img8.979902a9.jpg";